import { type EmailConfiguration } from '../../entities/Vendor'
import { type VendorApiModel } from '../api-models/VendorApiModel'

type EmailConfigurationApiModel = VendorApiModel['email_configurations']

export const mapEmailConfigurationApiModel = (
  data: EmailConfigurationApiModel
): Nullable<EmailConfiguration> => {
  if (!data) {
    return null
  }

  return Object.entries(data).reduce(
    (acc, [email, config]) => ({
      ...acc,
      [email]: {
        autoPo: config.auto_po,
        paymentRemittance: config.payment_remittance,
      },
    }),
    {} as EmailConfiguration
  )
}
